<template>
    <div class="drawABill">
        <div class="succeedIconContainer">
            <img src="../../assets/images/personalCenter/info.png" alt="">
        </div>
        <p>您的订单支付成功</p>
        <img src="../../assets/images/draw_a_billing.png" class="draw_a_billing">
    </div>
</template>

<script>
export default {
  name: "drawABill",
  data: function() {
    return {
      order_id: this.$route.query.order_id,
      order_sn: this.$route.query.order_sn,
    };
  },
  created: function() {
    this.$store.commit("set_current", 6);
    this.$store.commit("set_title", "nav.online");
    this.goToPaySuccessPage();
  },
  methods: {
    // 等待4秒跳转到支付成功的出票页面
    goToPaySuccessPage: function() {
      setTimeout(() => {
        this.$router.push({
          path: "/payInfo",
          query: { order_id: this.order_id, order_sn: this.order_sn,order_type:this.$route.query.order_type }
        });
      }, 4000);
    }
  }
};
</script>

<style scoped>
.succeedIconContainer {
  width: 100%;
  margin-top: 15%;
  margin-bottom: 5%;
  display: flex;
  justify-content: center;
}
.succeedIconContainer img {
  width: 70px;
  height: 70px;
}
.drawABill p {
  font-size: 1.3rem;
  font-weight: 550;
  text-align: center;
}
.draw_a_billing {
  width: 70%;
  display: inline-block;
  margin-top: 20px;
  position: relative;
  left: 15%;
}
</style>
